module.exports = __webpack_public_path__ + "img/couponB.5f1f2ab5.png";